module.exports = __webpack_public_path__ + "img/icn_whats.807669ec.svg";